const NON_CLICK_EVENT = 'non_click_event';
const XS = 'xs';
const addToDataLayer = props => {
  var _a;

  const {
    event,
    eventCategory,
    eventAction,
    eventLabel
  } = props;
  (_a = window === null || window === void 0 ? void 0 : window.dataLayer) === null || _a === void 0 ? void 0 : _a.push({
    event: event,
    event_category: eventCategory,
    event_action: eventAction,
    event_label: eventLabel
  });
};
const addXSEventToDataLayer = props => {
  const {
    eventAction,
    eventLabel
  } = props;
  addToDataLayer({
    event: NON_CLICK_EVENT,
    eventCategory: XS,
    eventAction,
    eventLabel
  });
};

class GUA {
  constructor() {
    this.name = 'Universal Analytics';
    this.experimentIds = new Set();
    this.experimentNames = new Set();
    this.variationsIds = new Set();
    this.variationNames = new Set();

    this.onExposure = experiment => {
      if (window && window.digital_data) {
        const {
          experimentId,
          experimentTextId,
          variationId,
          variationName
        } = experiment;
        this.experimentIds.add(experimentId);
        this.experimentNames.add(experimentTextId);
        this.variationsIds.add(`${experimentId}:${variationId}`);
        this.variationNames.add(`${experimentTextId}:${variationName}`);
        window.digital_data.experiments_ids = Array.from(this.experimentIds).join(',');
        window.digital_data.experiments_names = Array.from(this.experimentNames).join(',');
        window.digital_data.variants_ids = Array.from(this.variationsIds).join(',');
        window.digital_data.variant_names = Array.from(this.variationNames).join(',');
        addXSEventToDataLayer({
          eventAction: `${experimentTextId}:${experimentId}`,
          eventLabel: `${variationName}:${variationId}`
        });
      }
    };
  }

}

export { GUA as default };
